export class CashInPersonModel {
  name: string = '';
  email: string = '';
}

export class CashInModel {
  dueDate: string = '';
  person: CashInPersonModel = new CashInPersonModel();
  value: number = 0;
  idempotencyKey: string = '';
}
